import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FiMessageSquare, FiClock, FiArrowRight } from 'react-icons/fi';
import '../styles/ThankYou.css';

function ThankYou() {
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    // Disparar evento Purchase del Facebook Pixel
    if (window.fbq) {
      // eslint-disable-next-line no-undef
      fbq('track', 'Purchase', {
        value: 99.00,
        currency: 'USD',
        content_name: 'Entrenamiento Intensivo Online',
        content_ids: ['EIO-99'],
        content_type: 'product'
      });
    }
  }, []);

  useEffect(() => {
    // Animación de confeti
    const timer = setTimeout(() => setShowConfetti(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // Particles de confeti
  const Confetti = () => {
    const particles = Array.from({ length: 50 }).map((_, i) => (
      <motion.div
        key={i}
        className="confetti-particle"
        initial={{
          y: -10,
          x: Math.random() * 400 - 200,
          opacity: 1,
          rotate: 0,
        }}
        animate={{
          y: window.innerHeight + 10,
          opacity: 0,
          rotate: Math.random() * 720,
        }}
        transition={{
          duration: Math.random() * 2 + 2,
          ease: 'easeIn',
        }}
        style={{
          left: `${50 + (Math.random() - 0.5) * 100}%`,
          position: 'fixed',
          pointerEvents: 'none',
        }}
      >
        {Math.random() > 0.5 ? '🎉' : '✨'}
      </motion.div>
    ));
    return <div className="confetti-container">{particles}</div>;
  };

  const handleContactSupport = () => {
    window.open('https://wa.link/rixvbh', '_blank');
  };

  return (
    <div className="thank-you-page">
      {showConfetti && <Confetti />}

      <section className="thank-you-hero">
        <motion.div
          className="thank-you-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <motion.h1 
            className="thank-you-title"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            🟠 ¡Tu compra fue exitosa! 🎉
          </motion.h1>

          <motion.p 
            className="thank-you-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Bienvenido al Entrenamiento Intensivo de Enero – Estrategia Mecánica Inteligente (EMI).
          </motion.p>

          <motion.p 
            className="thank-you-description"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            Escríbenos vía WhatsApp enviándonos captura del pago. Adicional te pediremos tus datos de contacto y correo electrónico para el registro.
          </motion.p>

          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '30px' }}>
            <motion.button
              className="btn-whatsapp"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleContactSupport}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
            >
              <FiMessageSquare size={20} />
              Contactar por WhatsApp
            </motion.button>
          </div>
        </motion.div>
      </section>

      {/* Próximos Pasos */}
      <motion.section
        className="next-steps-section"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.9 }}
      >
        <div className="next-steps-container">
          <h2 className="section-title">Próximos pasos</h2>

          <div className="steps-list">
            {[
              {
                icon: '💬',
                title: 'Escríbenos por WhatsApp',
                description: 'Envía una captura del comprobante de pago para validar tu inscripción.\nNuestro equipo verificará tu acceso y te pedirá tus datos (nombre, número y correo).',
                time: '1 minuto',
                button: true,
              },
              {
                icon: '📧',
                title: 'Revisa tu correo',
                description: 'Una vez validemos tu inscripción, recibirás un correo de bienvenida con:\n• Fecha y horarios oficiales del entrenamiento. (Mañana, Tarde y Noche)',
                time: '5 minutos',
              },
              {
                icon: '👥',
                title: 'Únete al grupo privado de WhatsApp',
                description: 'Aquí recibirás recordatorios, instrucciones y comentarios.\nEl enlace llegará directamente a tu correo una vez confirmemos tu inscripción.',
                time: '1 minuto',
              },
              {
                icon: '📅',
                title: 'Día del entrenamiento',
                description: 'Conéctate al enlace que recibirás horas antes del entrenamiento en vivo por correo electrónico.\nRecuerda que debes registrarte, logearte y asistir puntual (15 min antes): El programa no se retransmite y es 100% EN VIVO.',
                time: 'En el mail',
              },
            ].map((step, index) => (
              <motion.div
                key={index}
                className="step-card"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 1.2 + index * 0.1 }}
              >
                <div className="step-number">
                  <span>{step.icon}</span>
                </div>
                <div className="step-content">
                  <h3 className="step-title">{step.title}</h3>
                  <p className="step-description">{step.description}</p>
                  {step.button && (
                    <motion.button
                      className="btn-whatsapp-small"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={handleContactSupport}
                      style={{ marginTop: '15px' }}
                    >
                      <FiMessageSquare size={16} />
                      Confirmar mi inscripción por WhatsApp
                    </motion.button>
                  )}
                </div>
                <div className="step-time">
                  <FiClock size={16} />
                  <span>{step.time}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* CTA Final */}
      <motion.section
        className="final-cta-section"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 1.8 }}
      >
        <div className="final-cta-container">
          <h2>¡Tu viaje comienza ahora!</h2>
          <p>
            Has tomado la decisión correcta. Ahora prepárate para transformar tu trading en 2026.
          </p>

          <motion.a
            href="/"
            className="btn-back-home"
            whileHover={{ scale: 1.05, paddingRight: 24 }}
            whileTap={{ scale: 0.95 }}
          >
            <span>Volver a la página de inicio</span>
            <FiArrowRight size={18} />
          </motion.a>
        </div>
      </motion.section>
    </div>
  );
}

export default ThankYou;
